export enum RouteParam {
    Subject = 'subject',
    Topic = 'topic',
    SubjectContent = 'subjectContent',
    SubjectGuide = 'subjectGuide',
    SubjectResource = 'subjectResource',
    TopicGuide = 'topicGuide',
    ResourceGuide = 'resourceGuide',
    CollectionTask = 'collectionTask',
}

export default RouteParam
